import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseFeatureWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-feature-welcome.component';
import {FeatureTypeService} from '@catmodules/core/services/index';
import {linkedResourceToGenericEmbeddedResource} from '@catmodules/core/utils/json-resources';
import {FeatureServicesService} from '@catmodules/models/feature-services/services/feature-services.service';
import {ServicesService} from '@catmodules/models/services/services/services.service';
import {SelectItem} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';

@Component({
  templateUrl: './feature-services-welcome.component.html',
})
export class FeatureServicesWelcomeComponent extends BaseFeatureWelcomeComponent {

  serviceOptions: SelectItem[];
  featureUnitsOptions: SelectItem[];
  resetAfterComplete = true;
  selfLabel = 'Feature Service';
  title = `New ${this.selfLabel}`;
  labels = {
    services: 'Services',
    featureUnits: 'Feature Units',
    dropdownPlaceholder: 'Select one',
    buttons: {last: `Save the ${this.selfLabel}`},
  };

  get formIsReady() {
    let isReady = !isNullOrUndefined(this.feature);
    isReady = isReady && !isNullOrUndefined(this.form);
    isReady = isReady && !isNullOrUndefined(this.featureUnitsOptions);
    isReady = isReady && !isNullOrUndefined(this.serviceOptions);
    return isReady;
  }

  constructor(private servicesService: ServicesService,
              private featureServicesService: FeatureServicesService,
              private formBuilder: FormBuilder,
              featureService: FeatureTypeService) {

    super(featureService);

    this.form = this.formBuilder.group({
      service: this.formBuilder.control('', [Validators.required]),
      featureUnit: this.formBuilder.control('', [Validators.required]),
    });
  }

  afterFeatureChanged(feature: any) {
    if (!isNullOrUndefined(feature)) {
      const units  = this.getFeatureService().extractConfigurableUnitsFor(feature);
      this.updateFeatureUnitOptions(units);
    }
  }

  validatePropertiesView() {
  }

  beforeDisplayProperties() {
    this.servicesService.getAll().subscribe((services: any[]) => {
      this.updateServiceOptions(services);
    });
  }

  saveNewEntity() {

    this.featureServicesService
      .create({
        featureUnit: this.form.value.featureUnit,
        service: this.form.value.service,
      })
      .subscribe((featureService) => {
        this.createdEntity = featureService;
        this.isCompleted = featureService !== null;
        this.getFeatureService().refreshCurrent();
      });
  }

  private updateOptionsList(items: any[]) {
    const optionList = [];
    items.forEach((item) => {
      optionList.push({label: item.name, value: item});
    });
    optionList.sort((o1, o2) => o1.label < o2.label ? -1 : 1);
    return optionList;
  }

  private updateServiceOptions(items: any[]) {
    this.serviceOptions = this.updateOptionsList(items);
  }

  private updateFeatureUnitOptions(linkedItems: any[]) {
    this.featureUnitsOptions = [];
    const optionList = [];
    linkedItems.forEach((item) => {
      optionList.push({label: item.label, value: linkedResourceToGenericEmbeddedResource(item)});
    });

    this.featureUnitsOptions = optionList;
    if (this.featureUnitsOptions.length > 0) {
      this.form.patchValue({featureUnit: this.featureUnitsOptions[0].value});
    }
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/features/components/landing-pages/feature-services-welcome/feature-services-welcome.component.ts